import { CSS } from "../../constants/css";
import { dialogBackgroundClick } from "../../utils/dialogBackdropClick";

const instance = ($modalTrigger: HTMLElement) => {
  const id = $modalTrigger.getAttribute("data-id");
  const $modal = document.querySelector<HTMLDialogElement>(`#${id}`);

  if (!id || !$modal) {
    return;
  }

  const isRemoveScrollbars
    = $modal.getAttribute("data-remove-scrollbars") === "true";
  const $modalClose = $modal.querySelectorAll(".js-close-modal");

  const hide = () => {
    $modal.close();
    document.body.appendChild($modal);

    if (isRemoveScrollbars) {
      document.documentElement.classList.remove(CSS.overflowHidden);
    }
  };

  const show = () => {
    $modal.showModal();

    if (isRemoveScrollbars) {
      document.documentElement.classList.add(CSS.overflowHidden);
    }

    // Add backdrop click event listener to hide if clicked
    $modal.addEventListener("click", (event: MouseEvent) => {
      dialogBackgroundClick(event, $modal, hide);
    });

    // Add event listeners to any other close button elements,
    // if they exist, identified by js class
    if (!$modalClose) {
      return;
    }

    $modalClose.forEach(($element) => {
      $element.addEventListener("click", (event) => {
        if (event.target !== $element) {
          return;
        }

        hide();
      });
    });
  };

  document.body.appendChild($modal);

  $modalTrigger.addEventListener("click", (event) => {
    event.preventDefault();
    show();
  });
};

export default () => {
  document.querySelectorAll<HTMLElement>(".js-modal-trigger").forEach(instance);
};
